/**
 * Shared layout for list pages: fill the layout outlet height and scroll only the table body.
 * Must be used together with Layout’s pinned-scroll routes (see Layout.js).
 */
export const tablePageRootSx = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minHeight: 0,
  maxHeight: '100%',
  overflow: 'hidden',
};

export const tablePageHeaderStickySx = {
  position: 'sticky',
  top: 0,
  zIndex: 9,
  backgroundColor: 'background.default',
  flexShrink: 0,
  pb: 1,
  px: { xs: 1.5, sm: 2 },
};

export const tablePageScrollRegionSx = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

export const tablePageTableContainerSx = {
  position: 'relative',
  maxWidth: '100%',
  flex: 1,
  minHeight: 0,
  height: '100%',
  overflowX: 'auto',
  overflowY: 'auto',
};
